import React, { useCallback, useEffect, useRef, useState } from 'react';
import usePromocionesStore from '../../store/promocionesStore';
import convertImageToBase64 from '../../utils/converitr-imagen-base64';
import { iframeOrigin, previewUrl } from '../../utils/previewOrigin';

const imagenesPreviewCache = new Map();

const normalizarImagenPreview = async (imagen) => {
    if (!imagen || imagen === 'existente') return '';
    if (imagen.startsWith('data:image/')) {
        return imagen.replace(/^data:image\/\w+;base64,/, '');
    }
    if (imagen.startsWith('http') || imagen.startsWith('/')) {
        if (imagenesPreviewCache.has(imagen)) return imagenesPreviewCache.get(imagen);
        const base64 = await convertImageToBase64(imagen);
        const normalizada = String(base64).replace(/^data:image\/\w+;base64,/, '');
        imagenesPreviewCache.set(imagen, normalizada);
        return normalizada;
    }
    return imagen;
};

const VistaPreviaImagenes = () => {
    const refIframe = useRef(null);
    const [iframeListo, setIframeListo] = useState(false);
    const { datos, imagen } = usePromocionesStore();
    
    const enviarImagenFlutter = useCallback(async () => {
      if (!iframeListo || !refIframe.current?.contentWindow) return;

      let imagenPreview = '';
      try {
        imagenPreview = await normalizarImagenPreview(imagen);
      } catch (error) {
        console.error('Error al preparar imagen de vista previa:', error);
      }
      refIframe.current.contentWindow.postMessage(
        { tipo: 'imagen_promocion', payload: JSON.stringify({
          texto_uno: datos.texto_uno,
          texto_dos: datos.texto_dos,
          imagen: imagenPreview,
          hexFondo: datos.hexFondo.replace('#', ''),
          hexTexto: datos.hexTexto.replace('#', '')
        }) },
        iframeOrigin(refIframe.current)
      );
    }, [datos, imagen, iframeListo]);

    useEffect(() => {
      enviarImagenFlutter().catch((error) => {
        console.error('Error al enviar vista previa de promoción:', error);
      });

      if (!iframeListo) return undefined;
      const timers = [250, 750, 1500].map((delay) => setTimeout(() => {
        enviarImagenFlutter().catch((error) => {
          console.error('Error al reenviar vista previa de promoción:', error);
        });
      }, delay));
      return () => timers.forEach(clearTimeout);
    }, [enviarImagenFlutter, iframeListo]);
    
    return (
        <div className="col-md-3" style={{ width: '370px', height: 'auto', }}>
            <label style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center',width: '100%',color: '#000' }}>Vista previa app</label>
            <div
                style={{
                width: '370px',
                height: '700px',
                background: '#222',
                borderRadius: '40px',
                border: '8px solid #222',
                boxShadow: '0 0 24px 2px #888',
                padding: '16px 8px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                }}
            >
                {/* Botón superior tipo "notch" */}
                <div
                style={{
                    width: '60px',
                    height: '8px',
                    background: '#444',
                    borderRadius: '8px',
                    margin: '0px auto 15px auto',
                }}
                />
                <iframe
                ref={refIframe}
                src={previewUrl('/promocion_imagenes')}
                onLoad={() => setIframeListo(true)}
                width="100%"
                height="680px"
                title="Vista previa"
                style={{
                    border: 'none',
                    borderRadius: '20px',
                    background: '#fff',
                    boxShadow: '0 0 0 2px #ccc',
                }}
                ></iframe>
            </div>
        </div>
    )
}

export default VistaPreviaImagenes
